// Restaurante Rentable — JS propio (vanilla, sin dependencias)
document.addEventListener('DOMContentLoaded', function () {
  initReveal();
  initContadores();
  initResenasArrastre();
  initGaleriaProducto();
  initVariantesProducto();
  initStickyCta();
});

// Barra de compra fija (móvil): se muestra mientras el botón principal no esté a la vista
// y se oculta sobre el formulario de la plantilla gratis y el footer. El clic reutiliza el
// botón real, así que el order bump y el seguimiento siguen funcionando igual.
function initStickyCta() {
  var barra = document.querySelector('[data-mt-sticky-cta]');
  var principal = document.querySelector('[data-mt-boton-comprar]');
  if (!barra || !principal || !('IntersectionObserver' in window)) return;
  // mt-scripts.js se incluye desde varias secciones: sin este guard el clic se registraba dos veces.
  if (barra.hasAttribute('data-mt-sticky-init')) return;
  barra.setAttribute('data-mt-sticky-init', '');
  var boton = barra.querySelector('[data-mt-sticky-cta-boton]');
  var visibles = {};
  function actualizar() {
    var oculta = principal.disabled || Object.keys(visibles).some(function (k) { return visibles[k]; });
    barra.hidden = oculta;
  }
  function observar(el, clave) {
    if (!el) return;
    new IntersectionObserver(function (entries) {
      visibles[clave] = entries[0].isIntersecting;
      actualizar();
    }).observe(el);
  }
  observar(principal, 'principal');
  observar(document.querySelector('.mt-lead'), 'lead');
  observar(document.querySelector('footer'), 'footer');
  boton.addEventListener('click', function () { principal.click(); });
  actualizar();
}

// Galería de producto: clic en miniatura cambia la imagen principal --------
function initGaleriaProducto() {
  var principal = document.querySelector('[data-mt-galeria-principal]');
  var miniaturas = document.querySelectorAll('[data-mt-miniatura]');
  if (!principal || !miniaturas.length) return;

  miniaturas.forEach(function (btn) {
    btn.addEventListener('click', function () {
      var nuevaUrl = btn.getAttribute('data-mt-miniatura');
      principal.src = nuevaUrl;
      miniaturas.forEach(function (b) { b.classList.remove('mt-activa'); });
      btn.classList.add('mt-activa');
    });
  });
}

// Selector de variantes: actualiza precio, id oculto y estado agotado ------
function initVariantesProducto() {
  var wrap = document.querySelector('[data-mt-producto-variantes]');
  if (!wrap) return;

  var dataEl = document.querySelector('[data-mt-variantes-json]');
  if (!dataEl) return;
  var variantes = JSON.parse(dataEl.textContent);

  var inputs = wrap.querySelectorAll('input[type="radio"]');
  var idInput = document.querySelector('[data-mt-variant-id]');
  var precioActual = document.querySelector('[data-mt-precio-actual]');
  var precioTachado = document.querySelector('[data-mt-precio-tachado]');
  var botonComprar = document.querySelector('[data-mt-boton-comprar]');

  function opcionesSeleccionadas() {
    var seleccion = {};
    wrap.querySelectorAll('[data-mt-opcion]').forEach(function (grupo) {
      var marcado = grupo.querySelector('input:checked');
      if (marcado) seleccion[grupo.getAttribute('data-mt-opcion')] = marcado.value;
    });
    return seleccion;
  }

  function encontrarVariante() {
    var seleccion = opcionesSeleccionadas();
    return variantes.find(function (v) {
      return v.opciones.every(function (o) { return seleccion[o.nombre] === o.valor; });
    });
  }

  function actualizar() {
    var variante = encontrarVariante();
    if (!variante) return;
    idInput.value = variante.id;
    if (precioActual) precioActual.textContent = variante.precioFormateado;
    if (precioTachado) {
      if (variante.compareFormateado) {
        precioTachado.textContent = variante.compareFormateado;
        precioTachado.style.display = '';
      } else {
        precioTachado.style.display = 'none';
      }
    }
    if (botonComprar) {
      botonComprar.disabled = !variante.disponible;
      botonComprar.textContent = variante.disponible ? botonComprar.getAttribute('data-mt-texto-disponible') : botonComprar.getAttribute('data-mt-texto-agotado');
    }
  }

  inputs.forEach(function (input) { input.addEventListener('change', actualizar); });
}

// Animación de entrada al hacer scroll -------------------------------------
function initReveal() {
  var els = document.querySelectorAll('.mt-reveal, .mt-reveal-scale');
  if (!els.length) return;

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduced) {
    els.forEach(function (el) { el.classList.add('mt-visible'); });
    return;
  }

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          var delay = entry.target.getAttribute('data-mt-delay') || 0;
          setTimeout(function () {
            entry.target.classList.add('mt-visible');
          }, Number(delay));
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.15, rootMargin: '0px 0px -40px 0px' }
  );

  els.forEach(function (el) { observer.observe(el); });
}

// Cifras animadas (count-up) -------------------------------------------------
function initContadores() {
  var nums = document.querySelectorAll('[data-mt-contador]');
  if (!nums.length) return;

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var el = entry.target;
        var target = parseFloat(el.getAttribute('data-mt-contador')) || 0;
        var suffix = el.getAttribute('data-mt-sufijo') || '';
        var decimals = el.getAttribute('data-mt-decimales') ? Number(el.getAttribute('data-mt-decimales')) : 0;

        if (reduced) {
          el.textContent = target.toFixed(decimals) + suffix;
          observer.unobserve(el);
          return;
        }

        var start = null;
        var duration = 1400;
        function paso(ts) {
          if (!start) start = ts;
          var progreso = Math.min((ts - start) / duration, 1);
          var eased = 1 - Math.pow(1 - progreso, 3);
          var valor = target * eased;
          el.textContent = valor.toFixed(decimals) + suffix;
          if (progreso < 1) requestAnimationFrame(paso);
        }
        requestAnimationFrame(paso);
        observer.unobserve(el);
      });
    },
    { threshold: 0.4 }
  );

  nums.forEach(function (el) { observer.observe(el); });
}

// Reseñas: permite arrastrar con el ratón además del scroll táctil ---------
function initResenasArrastre() {
  var track = document.querySelector('.mt-resenas-track');
  if (!track) return;

  var isDown = false;
  var startX, scrollLeft;

  track.addEventListener('mousedown', function (e) {
    isDown = true;
    track.classList.add('mt-arrastrando');
    startX = e.pageX - track.offsetLeft;
    scrollLeft = track.scrollLeft;
  });
  ['mouseleave', 'mouseup'].forEach(function (evt) {
    track.addEventListener(evt, function () {
      isDown = false;
      track.classList.remove('mt-arrastrando');
    });
  });
  track.addEventListener('mousemove', function (e) {
    if (!isDown) return;
    e.preventDefault();
    var x = e.pageX - track.offsetLeft;
    track.scrollLeft = scrollLeft - (x - startX) * 1.4;
  });
}

// Order bump: si el checkbox está marcado, agrega ambos productos al carrito.
// Sin marcar (o si algo falla) el formulario se envía normal.
// (mt-scripts.js se incluye desde varias secciones: el guard evita registrar el handler dos veces.)
if (!window.__mtBumpInit) document.addEventListener('submit', function (e) {
  var form = e.target;
  if (!form || !form.classList || !form.classList.contains('mt-producto-form')) return;
  var bump = form.querySelector('[data-mt-bump]');
  if (!bump || !bump.checked) return;
  var idInput = form.querySelector('[data-mt-variant-id]');
  if (!idInput) return;
  e.preventDefault();
  var items = [
    { id: Number(idInput.value), quantity: 1 },
    { id: Number(bump.getAttribute('data-mt-bump-variant')), quantity: 1 }
  ];
  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
    body: JSON.stringify({ items: items })
  }).then(function (r) {
    if (!r.ok) throw new Error('cart');
    window.location.href = '/cart';
  }).catch(function () {
    bump.checked = false;
    form.submit();
  });
});
window.__mtBumpInit = true;
